import { type MutableRefObject, useEffect, useState } from 'react';

type UseScrollableShowMoreProps = {
    endScrollableAreaRef: MutableRefObject<HTMLDivElement>;
    scrollableRef: MutableRefObject<HTMLDivElement>;
};

const useScrollableShowMore = ({
    endScrollableAreaRef,
    scrollableRef
}: UseScrollableShowMoreProps) => {
    const [showMore, setShowMore] = useState(false);
    const scrollContainer = (scrollableRef as MutableRefObject<HTMLDivElement>)?.current;
    const handleMoreClick = () => {
        scrollContainer.scrollTop += scrollContainer.clientHeight;
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setShowMore(scrollContainer?.clientHeight > 0 && !entry.isIntersecting);
            },
            { threshold: 1, root: endScrollableAreaRef?.current?.parentElement }
        );

        if (endScrollableAreaRef?.current) {
            observer.observe(endScrollableAreaRef.current);
        }

        return () => {
            setShowMore(false);
            if (endScrollableAreaRef?.current) {
                observer.unobserve(endScrollableAreaRef.current);
            }
        };
    }, [endScrollableAreaRef, scrollContainer?.clientHeight]);

    return { handleMoreClick, showMore };
};

export default useScrollableShowMore;
